/** เต็มแล้วหรือยัง — ใช้ปิด/แสดง "เต็มแล้ว" ที่ตัวเลือกฝั่งผู้ตอบล่วงหน้าเป็น best-effort เท่านั้น (quota_count มาจาก cache ตอนโหลดฟอร์ม อาจมีดีเลย์)
 *  การบังคับจริงอยู่ที่ backend เสมอ (ปฏิเสธ submit ถ้าเต็มไปแล้วจริง แม้ฝั่งนี้ยังไม่ทันอัปเดต) */
export function isChoiceFull(choice: { quota_limit?: number | null; quota_count?: number } | null | undefined): boolean {
  if (!choice || choice.quota_limit == null) return false;
  return (choice.quota_count ?? 0) >= choice.quota_limit;
}
